"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7814],{

/***/ 97814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ buy_sell_filter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./shared/components/advance-filter-dialog/index.tsx + 13 modules
var advance_filter_dialog = __webpack_require__(4651);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 5 modules
var Badge = __webpack_require__(71236);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/models/const/property-types.ts
var property_types = __webpack_require__(86465);
// EXTERNAL MODULE: ./api/realestate.request.ts + 1 modules
var realestate_request = __webpack_require__(13897);
// EXTERNAL MODULE: ./shared/components/message-modal/index.tsx
var message_modal = __webpack_require__(36481);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(68061);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/react/use-intl.esm2.js + 1 modules
var use_intl_esm2 = __webpack_require__(41616);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/buy-sell-filter/RadioGroupStatus.tsx




var _excluded = ["isCollection"];






var CustomLabel = function CustomLabel(_ref) {
  var active = _ref.active,
      label = _ref.label,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledCheckbox, {
    checked: active,
    onClick: onChange
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledLabel, null, label));
};

var RadioGroupStatus = function RadioGroupStatus(_ref2) {
  var isCollection = _ref2.isCollection,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var t = (0,use_intl_esm2/* default */.Z)("buy-sell-filter");

  var _useField = (0,formik_esm/* useField */.U$)(props),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var onChange = function onChange() {
    var value = field.value === "sale" ? "lease" : "sale";
    helpers.setValue(value);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledFormControl, null, (0,emotion_react_browser_esm/* jsx */.tZ)(RadioGroup/* default */.Z, (0,esm_extends/* default */.Z)({
    row: true
  }, field), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledFormControlLabel, {
    className: "".concat(field.value === "sale" ? "active" : "", " ").concat(isCollection ? "collection" : ""),
    value: "sale",
    control: (0,emotion_react_browser_esm/* jsx */.tZ)(Radio/* default */.Z, null),
    label: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomLabel, {
      label: t("shop"),
      active: field.value === "sale",
      onChange: onChange
    })
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledFormControlLabel, {
    value: "lease",
    className: "".concat(field.value === "lease" ? "active" : "", " ").concat(isCollection ? "collection" : ""),
    control: (0,emotion_react_browser_esm/* jsx */.tZ)(Radio/* default */.Z, null),
    label: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomLabel, {
      label: t("sell"),
      active: field.value === "lease",
      onChange: onChange
    })
  })));
};

var StyledFormControl = (0,styled/* default */.ZP)(FormControl/* default */.Z)(function (_ref3) {
  var _MuiFormGroupRoot;

  var theme = _ref3.theme;
  return {
    "& .MuiFormGroup-root": (_MuiFormGroupRoot = {
      display: "flex",
      flexWrap: "nowrap",
      position: "relative",
      left: 40,
      bottom: -3
    }, (0,defineProperty/* default */.Z)(_MuiFormGroupRoot, theme.breakpoints.down("lg"), {
      left: 20
    }), (0,defineProperty/* default */.Z)(_MuiFormGroupRoot, theme.breakpoints.down("md"), {
      left: 20
    }), _MuiFormGroupRoot)
  };
});
var StyledFormControlLabel = (0,styled/* default */.ZP)(FormControlLabel/* default */.Z)(function (_ref4) {
  var _ref5;

  var theme = _ref4.theme;
  return _ref5 = {
    margin: 0,
    backgroundColor: "var(--color-brand-red-main)",
    color: "#fff",
    padding: "8px 20px",
    border: "none",
    outline: "none",
    borderRadius: "10px 10px 0px 0px"
  }, (0,defineProperty/* default */.Z)(_ref5, theme.breakpoints.down("lg"), {
    borderRadius: "10px"
  }), (0,defineProperty/* default */.Z)(_ref5, theme.breakpoints.down("md"), {
    borderRadius: "10px"
  }), (0,defineProperty/* default */.Z)(_ref5, "&.active", {
    backgroundColor: "var(--color-brand-red-tertiary)",
    transform: "scale(1.1)",
    transition: "0.2s",
    fontSize: "12px"
  }), (0,defineProperty/* default */.Z)(_ref5, "& .MuiRadio-root", {
    display: "none",
    textAlign: "center"
  }), (0,defineProperty/* default */.Z)(_ref5, "& .MuiFormControlLabel-label", {
    cursor: "pointer",
    fontWeight: 500,
    fontFamily: "var(--font-family)",
    width: "100%",
    textAlign: "center",
    fontSize: "12px"
  }), (0,defineProperty/* default */.Z)(_ref5, "&.collection", {
    backgroundColor: "var(--color-brand-blue-main)"
  }), (0,defineProperty/* default */.Z)(_ref5, "&.collection.active", {
    backgroundColor: "#404041"
  }), _ref5;
});
var StyledLabel = (0,styled/* default */.ZP)("span")({
  cursor: "pointer",
  fontWeight: 500,
  fontFamily: "var(--font-family)",
  width: "100%",
  textAlign: "center",
  fontSize: "12px"
});
var StyledCheckbox = (0,styled/* default */.ZP)(Checkbox/* default */.Z)({
  padding: 0,
  marginRight: 5,
  "& .MuiSvgIcon-root": {
    width: 15,
    height: 15,
    color: "var(--color-brand-bg-secondary)"
  }
});
/* harmony default export */ var buy_sell_filter_RadioGroupStatus = (RadioGroupStatus);
// EXTERNAL MODULE: ./shared/components/auto-complete-field/index.tsx + 2 modules
var auto_complete_field = __webpack_require__(69891);
// EXTERNAL MODULE: ./shared/components/buy-sell-filter/util/form.util.ts
var form_util = __webpack_require__(2553);
// EXTERNAL MODULE: ./custom-hooks/use-cities.hook.ts + 2 modules
var use_cities_hook = __webpack_require__(78647);
// EXTERNAL MODULE: ./shared/models/functions/cities.helper.ts
var cities_helper = __webpack_require__(75769);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./shared/components/buy-sell-filter/index.tsx



var buy_sell_filter_excluded = ["citie", "description", "isSector"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















function BuySellFilter(props) {
  var t = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter");
  var translationNotFound = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter.notFound");
  var translation = (0,next_intl_cjs_production_min.useTranslations)("realestateList.typeFilters");
  var width = (0,use_width_hook/* useWidth */.z)();
  var isMobile = ["xs", "sm"].includes(width);
  var ref = (0,react.useRef)(null);
  var refButton = (0,react.useRef)();
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(""),
      search = _useState[0],
      onSearch = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var propertyTypes = (0,property_types/* useIntlPropertyTypes */.Pb)();
  var isCollection = router.asPath.includes(pages_path/* CPagesPath.es.collection */.K.es.collection);
  var propertyDetailRedirect = isCollection ? pages_path/* CPagesPath.es.collection_property_detail */.K.es.collection_property_detail : pages_path/* CPagesPath.es.property_detail */.K.es.property_detail;
  var collectionProperties = [translation("house"), translation("apartment"), translation("tourist"), translation("penthouse"), translation("project")];
  var collectionTypes = propertyTypes.filter(function (e) {
    return collectionProperties.includes(e.name);
  });
  var types = props.collection ? collectionTypes : propertyTypes;
  var handleSearch = react.useCallback(function (e) {
    var values = e.target.value;
    onSearch(values);
  }, []);

  var handleOpenModal = function handleOpenModal() {
    setOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setOpen(false);
  };

  var citiesList = (0,use_cities_hook/* default */.Z)({
    q: search
  }, 500);
  var getRealestateRequest = (0,useMutation/* useMutation */.D)(["detail-realstate"], function (realestateId) {
    return (0,realestate_request/* getRealestateDetails */.mW)(realestateId);
  });
  var submitValues = (0,lodash.debounce)(function (value) {
    var realestateId = parseInt(search);

    if (Boolean(realestateId)) {
      getRealestateRequest.mutateAsync(realestateId).then(function (r) {
        router.push({
          pathname: propertyDetailRedirect(r.data),
          query: _objectSpread(_objectSpread({}, router.query), props.params)
        });
      })["catch"](function () {
        return handleOpenModal();
      });
    } else {
      var _props$redirect;

      var route = (_props$redirect = props.redirect) !== null && _props$redirect !== void 0 ? _props$redirect : (router.pathname.length > 1 ? router.pathname : "") + pages_path/* CPagesPath.es.properties */.K.es.properties;
      var params = (0,form_util/* makeFilterObject */.U)(_objectSpread(_objectSpread({}, value), props.params));
      router.push({
        pathname: route,
        query: params
      });
    }
  }, 500);

  var handleLocationChange = function handleLocationChange(e, newValue) {
    // if enter was pressed
    if (e.keyCode === 13 && Boolean(parseInt(search))) {
      submitValues({});
    } else if (ref.current) {
      if (newValue.length == 2) {
        ref.current.setFieldValue("locations", [newValue[1]]);
        return;
      }

      ref.current.setFieldValue("locations", newValue);
    }
  };

  var isLoading = function isLoading() {
    if (Boolean(parseInt(search))) {
      return false;
    }

    return citiesList.isLoading;
  };

  var handleModal = function handleModal() {
    refButton.current.click();
  };

  var Cities_Options = citiesList.data ? (0,cities_helper/* default */.Z)(citiesList.data) : [];
  var Cities_noOptionsText = !((search === null || search === void 0 ? void 0 : search.length) > 2) ? t("searchHelp") : t("searchHelpSD");
  var initialValues = props.values ? props.values : form_util/* FormConfig.initialValues */.Z.initialValues;
  var handleSubmit = props.onSubmit ? props.onSubmit : submitValues;

  var Cities_getOptionLabel = function Cities_getOptionLabel(option) {
    return option === null || option === void 0 ? void 0 : option.description;
  };

  var Cities_renderOptions = function Cities_renderOptions(props, option) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(ItemElementLabel, (0,esm_extends/* default */.Z)({}, props, option));
  };

  var FormikConfig = {
    innerRef: ref,
    initialValues: initialValues,
    onSubmit: handleSubmit,
    enableReinitialize: true
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(FilterContent, {
    className: props.className
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Formik */.J9, FormikConfig, function (formikProp) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(CoverSearch, {
      id: "cover_search"
    }, !isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter_RadioGroupStatus, {
      name: "businessTypes",
      isCollection: props.collection
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverSearchBody, {
      className: "content-body",
      isCollection: props.collection
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      container: true
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 4,
      className: "typeProperty-autocomplete-container"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, null, t("youLookingFor")), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverAutoComplete, {
      name: "typeProperty",
      limitTags: 1,
      multiple: true,
      className: "typeProperty-autocomplete",
      placeholder: t("typePlaceholder"),
      getOptionLabel: function getOptionLabel(option) {
        return option === null || option === void 0 ? void 0 : option.description;
      },
      options: types.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          description: x.name,
          id: x.id
        });
      })
    })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(DividerSearch, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: true,
      onClick: function onClick(e) {
        if (isMobile) {
          e.preventDefault();
          handleModal();
        }
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, null, t("where")), (0,emotion_react_browser_esm/* jsx */.tZ)(LocationAutoComplete, {
      name: "locations",
      limitTags: 1,
      multiple: true,
      INPUT_DELAY: 600,
      loading: isLoading(),
      options: Cities_Options,
      onInputChange: handleSearch,
      className: "city-autocomplete",
      onChange: handleLocationChange,
      renderOption: Cities_renderOptions,
      value: formikProp.values.locations,
      noOptionsText: Cities_noOptionsText,
      freeSolo: Boolean(parseInt(search)),
      placeholder: t("locationPlaceholder"),
      getOptionLabel: Cities_getOptionLabel
    }))), (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonSubmit, {
      type: "submit",
      isCollection: props.collection
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: "/icons/loupe_remax_rd.svg",
      alt: "Loupe icon",
      width: "35px",
      height: "35px"
    }))), !props.collection && (0,emotion_react_browser_esm/* jsx */.tZ)(advance_filter_dialog/* default */.Z, {
      handleReset: formikProp.handleReset,
      handleSubmit: formikProp.handleSubmit,
      refButton: refButton
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonFilter, {
      type: "button",
      isCollection: props.collection
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: "/icons/filter_remax_rd.svg",
      alt: "Filter icon",
      width: "11px",
      height: "11px"
    }), " ", t("AdvanceFilters"), props.filtersCount > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter_Badge, null, props.filtersCount))));
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(message_modal/* ModalMessage */.P, {
    title: translationNotFound("title"),
    body: translationNotFound("body"),
    variant: "error",
    open: open,
    handleClose: handleCloseModal
  }));
}

/* harmony default export */ var buy_sell_filter = (BuySellFilter);

var ItemElementLabel = function ItemElementLabel(props) {
  var citie = props.citie,
      description = props.description,
      isSector = props.isSector,
      rest = (0,objectWithoutProperties/* default */.Z)(props, buy_sell_filter_excluded);

  var Wrap = (description === null || description === void 0 ? void 0 : description.length) > 8 ? "wrap" : "";
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    component: "li",
    sx: {
      width: "100%",
      display: "flex",
      "&.MuiAutocomplete-option.Mui-focused": {
        backgroundColor: "transparent",
        "&:hover span": {
          color: "white"
        }
      },
      "& .noWrap": {
        whiteSpace: "nowrap"
      },
      "& span": {
        color: "var(--color-brand-blue-main)",
        fontWeight: "bold",
        marginRight: "5px"
      },
      "& .isCity, .isSector": {
        color: "var(--color-brand-blue-main)"
      },
      "& .description": {
        color: "#989694",
        lineHeight: "20px"
      },
      "@media screen and (max-width: 450px)": {
        flexDirection: "column",
        alignItems: "start",
        whiteSpace: "nowrap",
        textAlign: "left",
        fontSize: "13px",
        "& .isCity": {
          width: "100%"
        },
        "& .description": {
          textAlign: "left",
          fontWeight: 400,
          width: "100%"
        }
      }
    }
  }, rest), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "noWrap isCity"
  }, description));
};

var Label = (0,styled/* default */.ZP)("span")({
  fontSize: "0.9rem",
  fontWeight: 600,
  cursor: "pointer",
  color: "var(--color-text-primary)"
});
var ButtonSubmit = (0,styled/* default */.ZP)(Button/* default */.Z)(function (_ref) {
  var isCollection = _ref.isCollection;
  return _objectSpread(_objectSpread({
    backgroundColor: "black",
    ":hover": {
      backgroundColor: "var(--color-brand-red-tertiary)"
    },
    border: "none",
    outline: "none",
    padding: "10px 20px",
    borderRadius: "15px",
    position: "absolute",
    right: "-10px",
    alignSelf: "center",
    cursor: "pointer"
  }, isCollection && {
    backgroundColor: "var(--color-brand-blue-main)",
    "&:hover": {
      backgroundColor: "var(--color-brand-blue-main)"
    }
  }), {}, {
    "& img": {
      verticalAlign: "middle"
    },
    "@media screen and (max-width: 767px)": {
      "& img": {
        width: "20px"
      }
    },
    "@media screen and (max-width: 450px)": {
      right: "-10px"
    }
  });
});
var DividerSearch = (0,styled/* default */.ZP)(Grid/* default */.ZP)({
  borderLeft: "1px solid var(--color-brand-blue-main)",
  height: "49px",
  width: "1px",
  margin: "auto 10px",
  marginTop: "5px",
  "@media screen and (max-width: 740px)": {
    display: "none"
  }
});
var ButtonFilter = (0,styled/* default */.ZP)(Button/* default */.Z)(function (_ref2) {
  var isCollection = _ref2.isCollection;
  return _objectSpread(_objectSpread({
    position: "absolute",
    top: "100%",
    right: "80px",
    backgroundColor: "var(--color-brand-red-main)",
    ":hover": {
      backgroundColor: "var(--color-brand-red-tertiary)"
    }
  }, isCollection && {
    backgroundColor: "var(--color-brand-blue-main)",
    "&:hover": {
      backgroundColor: "var(--color-brand-blue-main)"
    }
  }), {}, {
    textTransform: "none",
    color: "var(--color-text-white)",
    padding: "10px 22px",
    border: "none",
    outline: "none",
    borderRadius: "0 0 10px 10px",
    fontSize: "0.85rem",
    cursor: "pointer",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    "& img": {
      verticalAlign: "middle"
    },
    "@media screen and (max-width: 767px)": {
      marginBottom: "20px"
    }
  });
});
var CoverSearchBody = (0,styled/* default */.ZP)(Box/* default */.Z)(function (_ref3) {
  var isCollection = _ref3.isCollection;
  return _objectSpread(_objectSpread({
    backgroundColor: "#fff",
    position: "relative",
    zIndex: 10,
    padding: "8px 38px 10px 33px",
    borderRadius: "50px"
  }, isCollection && {
    borderRadius: "15px"
  }), {}, {
    display: "flex",
    height: "75px",
    "@media screen and (max-width: 767px)": {
      flexWrap: "wrap",
      padding: "15px 30px",
      height: "auto"
    },
    "@media screen and (max-width: 450px)": {
      borderRadius: "10px",
      padding: "15px 15px"
    }
  });
});
var CoverSearch = (0,styled/* default */.ZP)(formik_esm/* Form */.l0)({
  position: "relative",
  width: "840px",
  "@media screen and (max-width: 991px)": {
    width: "700px"
  },
  "@media screen and (max-width: 891px)": {
    width: "600px"
  },
  "@media screen and (max-width: 740px)": {
    width: "570px"
  },
  "@media screen and (max-width: 732px)": {
    width: "520px"
  },
  "@media screen and (max-width: 630px)": {
    width: "440px"
  },
  "@media screen and (max-width: 450px)": {
    width: "340px"
  }
});
var CoverAutoComplete = (0,styled/* default */.ZP)(auto_complete_field/* default */.Z)({
  width: "100%",
  border: "none",
  outline: "none",
  padding: "0px",
  "& .MuiAutocomplete-input": {
    padding: "4px 6px !important"
  },
  "& .MuiPaper-root.MuiAutocomplete-noOptions": {
    textTransform: "initial !important"
  },
  "& .MuiInputBase-fullWidth.MuiInputBase-root": {
    flexWrap: "nowrap",
    "&.Mui-focused": {
      position: "absolute",
      flexWrap: "wrap"
    }
  },
  "& .MuiInputBase-root": {
    marginTop: "-0.7rem !important",
    padding: "0px !important",
    backgroundColor: "white",
    "& *": {
      border: "none !important"
    }
  },
  "& .MuiAutocomplete-tag": {
    maxWidth: "110px",
    backgroundColor: "var(--color-brand-blue-main)",
    color: "white",
    fontWeight: 500
  },
  "& .MuiChip-deleteIcon": {
    color: "white !important"
  },
  "& span.MuiAutocomplete-tagSizeMedium": {
    borderRadius: "100%",
    width: "20px",
    height: "20px",
    fontSize: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  "& .Mui-focused .MuiAutocomplete-tag": {
    maxWidth: "calc(100% - 6px)"
  },
  "& .city-autocomplete": {
    width: "100%"
  }
});
var LocationAutoComplete = (0,styled/* default */.ZP)(auto_complete_field/* AutoCompleteField */.K)({
  width: "100%",
  border: "none",
  outline: "none",
  padding: "0px",
  "& .MuiAutocomplete-input": {
    padding: "4px 6px !important"
  },
  "& .MuiPaper-root.MuiAutocomplete-noOptions": {
    textTransform: "initial !important"
  },
  "& .MuiInputBase-fullWidth.MuiInputBase-root": {
    flexWrap: "nowrap",
    "&.Mui-focused": {
      position: "absolute",
      flexWrap: "wrap"
    }
  },
  "& .MuiInputBase-root": {
    marginTop: "-0.7rem !important",
    padding: "0px !important",
    backgroundColor: "white",
    "& *": {
      border: "none !important"
    }
  },
  "& .MuiAutocomplete-tag": {
    backgroundColor: "var(--color-brand-blue-main)",
    color: "white",
    fontWeight: 500
  },
  "& .MuiChip-deleteIcon": {
    color: "white !important"
  },
  "& span.MuiAutocomplete-tagSizeMedium": {
    borderRadius: "100%",
    width: "20px",
    height: "20px",
    fontSize: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  "& .Mui-focused .MuiAutocomplete-tag": {
    maxWidth: "calc(100% - 6px)"
  },
  "& .city-autocomplete": {
    width: "100%"
  }
});
var FilterContent = (0,styled/* default */.ZP)(Box/* default */.Z)({
  margin: "auto",
  "@media screen and (max-width: 740px)": {
    "& .typeProperty-autocomplete-container": {
      display: "none"
    }
  }
});
var buy_sell_filter_Badge = (0,styled/* default */.ZP)(Badge/* default */.Z)({
  minWidth: "20px",
  minHeight: "20px",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  color: "var(--color-brand-bg-secondary)",
  backgroundColor: "var(--color-brand-blue-main)",
  fontSize: "0.75rem",
  fontWeight: 600,
  top: "18px",
  right: "0"
});

/***/ })

}]);